export enum CanvasV2EventTypeEnum {
    COMPLETE = 'canvas:complete',
    ERROR = 'canvas:error',
    PLAN_COMPLETE = 'canvas:plan_complete',
    TOPIC_SEARCH_TOOL_CALL = 'canvas:topic_search:tool_call',
    TOPIC_SEARCH_TOPIC_COMPLETE = 'canvas:topic_search:topic_complete',
    TOPIC_SEARCH_COMPLETE = 'canvas:topic_search:complete',
    EVALUATE_COMPLETE = 'canvas:evaluate_complete',
    TOPIC_REFINE_TOOL_CALL = 'canvas:topic_refine:tool_call',
    TOPIC_REFINE_TOPIC_COMPLETE = 'canvas:topic_refine:topic_complete',
    TOPIC_REFINE_COMPLETE = 'canvas:topic_refine:complete'
}
